import { DriverRegistrationPortalNoAuthService } from '@bolteu/bolt-server-api-driver-registration';
import { IAppState } from '../types';

export const getExperimentParameters =
  (eventKey: string) =>
  (
    state: IAppState
  ): DriverRegistrationPortalNoAuthService.ExperimentParameters =>
    state.experiments[eventKey];
